module.exports = __webpack_public_path__ + "static/media/mckinsey challenges.97a88f17.svgz";